import React from "react";
import { getColor } from "./getColor";
import { InvoiceIconType } from "./invoice.icon";

const BaseIcon = ({ active }: InvoiceIconType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9167 20H2.08333C0.935 20 0 19.0658 0 17.9167V2.08333C0 0.934167 0.935 0 2.08333 0H17.9167C19.065 0 20 0.934167 20 2.08333V17.9167C20 19.0658 19.065 20 17.9167 20ZM2.08333 0.833333C1.39417 0.833333 0.833333 1.39417 0.833333 2.08333V17.9167C0.833333 18.6058 1.39417 19.1667 2.08333 19.1667H17.9167C18.6058 19.1667 19.1667 18.6058 19.1667 17.9167V2.08333C19.1667 1.39417 18.6058 0.833333 17.9167 0.833333H2.08333Z"
        fill={getColor(active)}
      />
      <path
        d="M16.25 8.33333H3.75C3.06083 8.33333 2.5 7.7725 2.5 7.08333V3.75C2.5 3.06083 3.06083 2.5 3.75 2.5H16.25C16.9392 2.5 17.5 3.06083 17.5 3.75V7.08333C17.5 7.7725 16.9392 8.33333 16.25 8.33333ZM3.75 3.33333C3.52 3.33333 3.33333 3.52083 3.33333 3.75V7.08333C3.33333 7.3125 3.52 7.5 3.75 7.5H16.25C16.48 7.5 16.6667 7.3125 16.6667 7.08333V3.75C16.6667 3.52083 16.48 3.33333 16.25 3.33333H3.75Z"
        fill={getColor(active)}
      />
    </svg>
  );
};

export default BaseIcon;
